export default "__VITE_ASSET__Cp5RTIQ4__"